import React from 'react';

export const HighlightMatch = (text, search = '') => {
  if (!search) return text;

  const regex = new RegExp(`(${search})`, 'i'); // case-insensitive match
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? <strong key={index}>{part}</strong> : <React.Fragment key={index}>{part}</React.Fragment>
  );
};
